export default __webpack_public_path__ + "static/media/ck.e52d733f.svg";